"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScapiPostdirektApi = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("../utils");
class ScapiPostdirektApi {
  constructor(config) {
    this.fetch = (0, _utils.createScapiFetch)(config, 'postdirekt');
  }
  getPostalCodes(...args) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `postalcodes`;
      return _this.fetch(url, 'GET', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
  getCities(...args) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `cities`;
      return _this2.fetch(url, 'GET', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
  getPostalcodeCities(...args) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `postalcodes_cities`;
      return _this3.fetch(url, 'GET', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
  getStreets(...args) {
    var _this4 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `postalcodes_cities_districts_streets`;
      return _this4.fetch(url, 'GET', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
  getBuildings(...args) {
    var _this5 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `buildings`;
      return _this5.fetch(url, 'GET', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
}
exports.ScapiPostdirektApi = ScapiPostdirektApi;